import { createAction, props } from '@ngrx/store';
import { OGMeta } from './meta';

const setMetaTags = createAction('og:meta set tags', props<{ tags: OGMeta }>());

export const OgMetaTagsActions = {
  setMetaTags,
};
